import {
  DollarOutlined,
  HomeOutlined,
  LineChartOutlined
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import NavigationMenu from 'components/MainNavigationMenu';
import { MenuItem } from 'components/MainNavigationMenu/types';
import { useRouter } from 'next/router';

const EventMenu = ({ isOrganizer }: { isOrganizer: boolean }) => {
  const { t } = useTranslation(['events']);
  const router = useRouter();
  const { query } = router;

  const menuItems: MenuItem[] = [
    {
      condition: () => true,
      label: t('events:dashboard.menu.dashboard'),
      value: '/events/[slug]/dashboard',
      icon: <HomeOutlined />
    },
    {
      condition: () => true,
      label: t('events:dashboard.menu.financials'),
      value: '/events/[slug]/financials',
      icon: <DollarOutlined />
    },
    {
      condition: () => true,
      label: t('events:dashboard.menu.analytics'),
      value: '/events/[slug]/analytics',
      icon: <LineChartOutlined />
    }
  ];

  const handleEventRouteChange = (newPath: string) => {
    if (newPath !== '') {
      let newRoute = newPath;

      // Replace dynamic route parameters
      if (query.slug && typeof query.slug === 'string') {
        newRoute = newRoute.replace('[slug]', query.slug);
      }

      router.push(newRoute);
    }
  };

  return (
    <div className="flex justify-center  mt-8">
      <NavigationMenu
        isAdmin={isOrganizer}
        isUserMember={isOrganizer}
        menuItems={menuItems}
        onRouteChange={handleEventRouteChange}
      />
    </div>
  );
};

export default EventMenu;
